import { render, staticRenderFns } from "./HudSwiper.vue?vue&type=template&id=90b2971e&scoped=true&"
import script from "./HudSwiper.vue?vue&type=script&lang=js&"
export * from "./HudSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HudSwiper.vue?vue&type=style&index=0&id=90b2971e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b2971e",
  null
  
)

export default component.exports